import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  createAgreementStatusCurrent,
  createAgreementStatusPeriod,
  createSettlementType,
  createTaxStatusPeriod,
  createContractorCardS3Key,
  createTaxStatusCurrent,
} from "../columns";
import { PayrollInspectionPreview } from "../types";

export const usePayrollPreviewColumnOverrides = (
  isRoleBased: boolean,
): Record<string, ColumnDef<PayrollInspectionPreview>> => {
  const { t } = useTranslation();

  return useMemo(() => {
    const commonColumns: Record<string, ColumnDef<PayrollInspectionPreview>> = {
      agreement_status_period: createAgreementStatusPeriod(t),
      agreement_status_current: createAgreementStatusCurrent(t),
    };

    const roleColumns: Record<string, ColumnDef<PayrollInspectionPreview>> = {
      settlement_type: createSettlementType(t),
      tax_status_period: createTaxStatusPeriod(t),
      tax_status_current: createTaxStatusCurrent(t),
      contractor_card_s3_key: createContractorCardS3Key(),
    };

    return {
      ...commonColumns,
      ...(isRoleBased ? roleColumns : {}),
    };
  }, [isRoleBased, t]);
};
